<template>
  <!-- Floating Custom Select -->
  <div
    class="tw-absolute tw-top-4 tw-z-50 tw-w-full tw-pl-[16px] tw-pr-[16px] md:tw-left-1/2 md:tw-top-4 md:tw-max-w-[450px] md:-tw-translate-x-1/2 lg:tw-hidden"
  >
    <div
      class="tw-relative tw-flex tw-h-[50px] tw-w-full tw-items-center tw-justify-between tw-rounded-[30px] tw-border tw-border-[#D1D5DB] tw-bg-white tw-px-[16px] tw-px-[24px] tw-py-[4px] tw-font-medium tw-text-[#374151] tw-shadow-[0_21px_6px_0_rgba(0,0,0,0.00),0_13px_5px_0_rgba(0,0,0,0.01),0_7px_4px_0_rgba(0,0,0,0.03),0_3px_3px_0_rgba(0,0,0,0.04),0_1px_2px_0_rgba(0,0,0,0.05)]"
    >
      <!-- Dropdown trigger / input -->
      <div
        class="tw-flex tw-w-full tw-items-center tw-justify-between tw-text-[14px] tw-font-semibold"
      >
        <!-- Left icon -->
        <img
          :src="cdnAsset('svg/listings/uh-uni-student.svg')"
          alt="University Student Icon"
          class="tw-h-[18px] tw-w-[18px]"
        />

        <!-- Label or Input -->
        <div class="tw-flex-grow tw-px-3">
          <template v-if="isOpen">
            <input
              ref="searchInput"
              v-model="searchQuery"
              type="text"
              placeholder="Start typing"
              class="tw-w-full tw-border-none tw-bg-transparent tw-text-[16px] tw-font-normal tw-text-[#6B7280] focus:tw-outline-none focus:tw-ring-0"
              @click.stop
            />
          </template>
          <template v-else>
            <button
              type="button"
              class="tw-w-full tw-border-none tw-bg-transparent tw-text-left focus:tw-border-transparent focus:tw-outline-none focus:tw-ring-0 active:tw-outline-none"
              @click="toggleDropdown"
            >
              {{ selectedUniversityLabel }}
            </button>
          </template>
        </div>

        <!-- Dynamic Arrow icon -->
        <img
          :key="isOpen"
          :src="
            isOpen
              ? cdnAsset('svg/listings/uh-caret-up.svg')
              : cdnAsset('svg/listings/uh-caret-down.svg')
          "
          :alt="isOpen ? 'Up' : 'Down'"
          class="tw-h-[18px] tw-w-[18px] tw-cursor-pointer"
          @click="toggleDropdown"
        />
      </div>

      <!-- Dropdown Menu -->
      <div
        v-if="isOpen"
        class="tw-absolute tw-left-0 tw-top-[60px] tw-z-50 tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-[8px] tw-rounded-[24px] tw-border tw-border-[#D1D5DB] tw-bg-white tw-p-[16px] tw-text-[16px] tw-font-[400] tw-shadow-lg"
      >
        <div class="tw-max-h-[290px] tw-w-full tw-overflow-y-auto">
          <!-- "Hide directions" first -->
          <div class="tw-w-full">
            <button
              type="button"
              class="tw-flex tw-w-full tw-items-center tw-gap-3 tw-rounded-[16px] tw-px-[12px] tw-py-[8px] hover:tw-bg-gray-100"
              @click="selectOption('Hide directions')"
            >
              <span class="tw-flex-grow tw-text-left">Hide directions</span>
              <span class="tw-flex-shrink-0">
                <img
                  :src="
                    selectedUniversityLabel === 'Hide directions'
                      ? cdnAsset('svg/listings/uh-eliipse-selected.svg')
                      : cdnAsset('svg/listings/uh-eliipse.svg')
                  "
                  alt="Hide directions"
                  class="tw-h-[18px] tw-w-[18px]"
                />
              </span>
            </button>
            <hr class="tw-my-2 tw-w-full tw-border-t tw-border-[#D1D5DB]" />
          </div>

          <!-- Filtered University options -->
          <div
            v-for="(option, index) in filteredUniversities"
            :key="option.id || index"
            class="tw-w-full"
          >
            <button
              type="button"
              class="tw-flex tw-w-full tw-items-center tw-gap-3 tw-rounded-[16px] tw-px-[12px] tw-py-[8px] hover:tw-bg-gray-100"
              @click="selectOption(option)"
            >
              <span class="tw-flex-grow tw-text-left">{{ option.name }}</span>
              <span class="tw-flex-shrink-0">
                <img
                  :src="
                    selectedUniversityLabel === option.name
                      ? cdnAsset('svg/listings/uh-eliipse-selected.svg')
                      : cdnAsset('svg/listings/uh-eliipse.svg')
                  "
                  :alt="option.name"
                  class="tw-h-[18px] tw-w-[18px]"
                />
              </span>
            </button>
          </div>

          <!-- No results message -->
          <div
            v-if="filteredUniversities.length === 0"
            class="tw-py-4 tw-text-center tw-text-sm tw-text-gray-500"
          >
            No universities found.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UniversitySearchFilter',
  props: {
    universities: {
      type: Array,
      default: () => [],
    },
    selectedUniversityPin: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
      selectedUniversity: null,
      searchQuery: '',
    };
  },
  computed: {
    selectedUniversityLabel() {
      if (!this.selectedUniversity) {
        return 'Select university for travel times';
      }
      return typeof this.selectedUniversity === 'string'
        ? this.selectedUniversity
        : this.selectedUniversity.name;
    },
    filteredUniversities() {
      const query = this.searchQuery.trim().toLowerCase();
      console.log('query', query);
      console.log('universities', this.universities);

      if (!query) return this.universities;
      return this.universities.filter((u) =>
        u.name.toLowerCase().includes(query)
      );
    },
  },
  watch: {
    selectedUniversityPin: function () {
      this.selectedUniversity = this.selectedUniversityPin;
    },
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.$nextTick(() => this.$refs.searchInput?.focus());
      } else {
        this.searchQuery = '';
      }
    },
    selectOption(option) {
      this.selectedUniversity = option;
      this.isOpen = false;
      this.searchQuery = '';

      if (typeof option === 'string' && option === 'Hide directions') {
        this.resetMapView();
      } else {
        this.showDirectionsToUniversity(option);
      }
    },
    resetMapView() {
      this.selectedUniversity = null;
      this.isOpen = false;
      this.$emit('university-hidden');
    },
    showDirectionsToUniversity(option) {
      this.$emit('university-selected', option);
    },
  },
};
</script>
